export class AssessmentResult {
  id: number;
  type: string;
  note: number;
  total: number;
  assessmentId: string;

  constructor(assessmentResult: Partial<AssessmentResult>) {
    this.id = assessmentResult.id;
    this.type = assessmentResult.type ?? '';
    this.note = assessmentResult.note ?? 0;
    this.total = assessmentResult.total ?? 0;
    this.assessmentId = assessmentResult.assessmentId;
  }
}
